import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60d2b43f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "portfolio" }
const _hoisted_2 = {
  class: "category-selection",
  role: "navigation",
  "aria-label": "Portfolio categories"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Quote = _resolveComponent("Quote")!
  const _component_Header = _resolveComponent("Header")!
  const _component_CategoriesButton = _resolveComponent("CategoriesButton")!
  const _component_PortfolioExample = _resolveComponent("PortfolioExample")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Quote, {
      quote: "quote-emil-cioran",
      author: "Emil Cioran"
    }),
    _createVNode(_component_Header, {
      title: "portfolio",
      subtitle: _ctx.selectedCategory
    }, null, 8, ["subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, i) => {
        return (_openBlock(), _createBlock(_component_CategoriesButton, {
          key: i,
          text: category,
          onChangeCategory: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedCategory = $event))
        }, null, 8, ["text"]))
      }), 128))
    ]),
    _createElementVNode("section", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portfolioArray, (portfolioItem) => {
        return (_openBlock(), _createBlock(_component_PortfolioExample, {
          "portfolio-item": portfolioItem,
          "selected-category": _ctx.selectedCategory,
          key: portfolioItem.name
        }, null, 8, ["portfolio-item", "selected-category"]))
      }), 128))
    ])
  ]))
}